module.exports = __webpack_public_path__ + "web/img/grade4.a36ea9a7.png";